import { CountdownProviderAddAction, CountdownProviderRemoveAction, COUNTDOWN_PROVIDER_ADD, COUNTDOWN_PROVIDER_REMOVE, useCountdownStore } from "providers/CountdownProvider";
import { useCallback, useEffect, useState } from "react";
import { getUniqueKey } from "utils/KeyUtils";

export interface IUseCountdownReturn {
  counter: number,
  cancel: Function,
  toRestart: Function
}

export default (
  total: number,
  callbackStarted?: Function | null,
  callbackProgress?: (count: number) => void | null,
  callbackEnded?: Function | null,
  autoRestart?: boolean | null,
):IUseCountdownReturn => {
  const [countdownKey, setCountdownKey] = useState<string>(getUniqueKey());
  const [initializer, setInitializer] = useState(false);
  const {state, dispatch} = useCountdownStore();
  const [isEnded, setIsEnded] = useState<boolean>();
  const [canceled, setCanceled] = useState<boolean>(false);

  const showCounter = (counter: number) => {
    return counter < 0 ? 0 : counter;
  }

  const toRestart = useCallback(() => {
    setCountdownKey(getUniqueKey())
    setInitializer(false);
  }, [setInitializer]);

  const getCounter = useCallback((): number => {
    const counterByKey = countdownKey ? state.counters[countdownKey] : null;
    if (counterByKey && !canceled) {
      const num: number = counterByKey.startCounter - (state.globalCounter - counterByKey.startGlobalCounter);
      if (num >= -1) {
        if (typeof callbackProgress === 'function') {
          callbackProgress(num);
        }
        if (num <= -1) {
          if (!isEnded) {
            setIsEnded(true);
            if (typeof callbackEnded === 'function') {
              callbackEnded();
            }
            if (autoRestart) {
              toRestart();
            }
          }
        }
        return num;
      }
    }
    return 0;
  }, [isEnded, countdownKey, callbackProgress, callbackEnded, autoRestart, toRestart, state, canceled]);

  // eslint-disable-next-line
  useEffect(() => {
    if (!initializer) {
      if (typeof callbackStarted === 'function') {
        callbackStarted();
      }
      setInitializer(initializer);
      setCanceled(false);
      setIsEnded(false);
      dispatch({
        type: COUNTDOWN_PROVIDER_ADD,
        key: countdownKey,
        startCounter: total
      } as CountdownProviderAddAction);
    }
    return () => {
      dispatch({
        type: COUNTDOWN_PROVIDER_REMOVE,
        key: countdownKey,
      } as CountdownProviderRemoveAction);
    }
  }, [countdownKey, dispatch, total, initializer, setInitializer, setCountdownKey, callbackStarted])

  return {
    counter: showCounter(getCounter()),
    cancel: () => {
      setCanceled(true);
    },
    toRestart
  } 
}